export class ValidationHistory {
  name: string = "";
  date: string = "";
  result: string = "";
  dataset: string = "";
  version: string = "";
  schema: string = "";
  bizrule: string = "";
  certificate: string = "";

  constructor(init?: Partial<ValidationHistory>) {
    Object.assign(this, init);
  }

  static parse(data: any): ValidationHistory {
    return new ValidationHistory({
      name: data.name ?? "",
      date: data.date ?? "",
      result: data.result ?? "",
      dataset: data.dataset ?? "",
      version: data.version ?? "",
      schema: data.schema ?? "",
      bizrule: data.bizrule ?? "",
      certificate: data.certificate ?? "",
    });
  }
}
